module.exports = __webpack_public_path__ + "static/img/webclip-placeholder.4f8bc54f.png";